import { defineComponent, computed } from "vue";
import { definePropType } from "@types-vue/props";
import pick from "lodash/pick";
export default defineComponent({
    props: {
        // 按钮类型
        type: {
            type: definePropType(String),
            default: "filled"
        },
        // 按钮大小
        size: {
            type: definePropType(String),
            default: "normal"
        },
        // 是否是图标按钮
        icon: {
            type: Boolean,
            default: false
        },
        // 是否使用mini尺寸规范
        // pt平台工具制作页应该使用mini组件尺寸，以符合设计规范要求，每个普通尺寸组件都有一个mini尺寸
        mini: {
            type: Boolean,
            default: false
        },
        // 按钮颜色类型
        theme: {
            type: definePropType(String),
            default: "brand"
        },
        // 按钮禁用
        disabled: {
            type: Boolean,
            default: false
        },
        // 按钮加载
        loading: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props) {
        var ptCommonButton = computed(function() {
            var classList = [
                "pt-common-button",
                "pt-button-".concat(props.type),
                "pt-button-".concat(props.size),
                "pt-button-".concat(props.theme), 
            ];
            if (props.icon) {
                classList.push("pt-button-icon");
            }
            if (props.mini) {
                classList.push("pt-button-mini");
            }
            return classList;
        });
        return {
            pick: pick,
            ptCommonButton: ptCommonButton
        };
    }
});
